import { useParams } from 'react-router-dom';
import React, { Suspense } from 'react';
import { PropertyDetailsLayout } from '@acp/core-ui';
import { NotFoundPage } from './not-found';

const ViewPropertyRequestPage = React.lazy(() => import('../features/property-request/pages/view-page'));

export function ViewWorkOrder() {
    const params = useParams();

    const { propertyRequestId } = params;

    if (propertyRequestId === undefined) {
        return <NotFoundPage />;
    }

    return (
        <Suspense fallback={<PropertyDetailsLayout.Skeleton />}>
            <ViewPropertyRequestPage propertyRequestId={propertyRequestId} />
        </Suspense>
    );
}
